/* @flow */
import React, {PropTypes} from 'react';
import Autosuggest from 'react-autosuggest';
import ProfessionsService from 'frilans-finans/professions/professions-service';
import styles from './profession.scss';
import loadingStyles from './profession-loading.scss';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import ErrorMessage from '../error-message/error-message';

// Timeout variables doesn't play well with state
let requestValue = '';

// TO DO : IF SUGGESTIONSDROPDOWN STATE IS TRUE, E.preventDEFAULT FOR ENTERCLICKS

export class Profession extends React.Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    showErrorWithoutBlur: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      inputValue: this.props.value,
      value: {
        name: this.props.value
      },
      suggestions: [],
      loading: false,
      fetchError: false,
      showSelectError: false,
      showErrorWithoutBlur: this.props.showErrorWithoutBlur,
      noResults: false
    };

    this.renderInputComponent = this.renderInputComponent.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.getSuggestions = this.getSuggestions.bind(this);
  }

  componentDidMount () {
    if (this.state.inputValue && this.state.inputValue !== '') {
      this.getSuggestions({value: this.state.inputValue});
    }
  }

  /**
   * Called when user clicks the submit button
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    const showError = nextProps.showErrorWithoutBlur && !this.state.value.ssyk;
    this.setState({showErrorWithoutBlur: showError});
  }

  startRequestTimeout () {
    if (this.requestTimeout) {
      window.clearTimeout(this.requestTimeout);
    }

    this.requestTimeout = setTimeout(this.makeRequest.bind(this), 300);
  }

  makeRequest () {
    this.setState({loading: true}, function () {
      ProfessionsService.getByTitle(requestValue)
        .then((response) => this.onAPIResponse(response));
    });
  }

  onAPIResponse (response) {
    var professions;

    professions = response.collection;

    this.setState({
      loading: false,
      noResults: !(Boolean(professions.length) || false),
      suggestions: professions
    });
  }

  /**
   * When user selects an option
   */
  onSuggestionSelected (event, { suggestion, suggestionValue, sectionIndex, method }) {
    this.setState({
      value: suggestion
    });

    this.sendValueToParent(suggestion, true);

    event.preventDefault();
  }

  sendValueToParent (suggestion, valid) {
    this.props.callback(this.props.name, {
      value: suggestion.title,
      valid: valid,
      id: suggestion.id
    });
  }

  // Prevent reload after selection
  onKeyDown (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.target.blur();
    }
  }
  /**
   * onChange from input
   */
  onChange (event, { newValue }) {
    var noResultsString = proxyCounterpart('NO_RESULTS_FOUND');

    let suggestion = {title: newValue};

    this.setState({
      value: suggestion
    });

    this.sendValueToParent(suggestion, !!suggestion.id);

    if (newValue !== noResultsString) {
      this.setState({
        inputValue: newValue
      }, () => {
        if (this.state.inputValue === '') {
          this.setState({
            value: {
              name: '',
              valid: false
            }
          });

          this.props.callback(this.props.name, {
            value: '',
            valid: false
          });
        }
      });
    }
  }

  renderInputComponent (inputProps) {
    var placeholder = proxyCounterpart('PROFESSION');
    return (
      <div>
        <input id={this.props.name} {...inputProps} required />
        <label htmlFor={this.props.name} placeholder={placeholder} alt={placeholder}/>
      </div>
    );
  }

  /**
   * AutoSuggest wants new suggestions based on input
   */
  onSuggestionsUpdateRequested ({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  }

  /**
   * Get professions from API
   */
  getSuggestions ({ value }) {
    var inputValue;

    inputValue = value.trim().toLowerCase();

    if (!inputValue) {
      this.setState({
        loading: false,
        professions: []
      });

      return;
    }

    requestValue = value;
    this.startRequestTimeout();
  }

  onSuggestionsClearRequested () {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionValue (suggestion) {
    return suggestion.title;
  }

  renderSuggestion (suggestion) {
    return (
      <span>{suggestion.title}</span>
    );
  }

  render () {
    var inputProps, theme;

    inputProps = {
      value: this.state.inputValue,
      onChange: this.onChange,
      name: this.props.name,
      onKeyDown: this.onKeyDown
    };

    theme = this.state.loading ? {...loadingStyles, styles} : {...styles};

    return (
      <div className='input-wrapper profession'>
        <Autosuggest
          suggestions={this.state.suggestions}
          theme={theme}
          onSuggestionsFetchRequested={this.getSuggestions}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          renderInputComponent={this.renderInputComponent}
          focusFirstSuggestion />
        <ErrorMessage show={this.state.fetchError} errorMessage={proxyCounterpart('GENERAL_ERROR')}/>
        <ErrorMessage show={this.state.showErrorWithoutBlur} errorMessage={proxyCounterpart('PROFESSION_ERROR')}/>
      </div>
    );
  }
}

export default Profession;



/** WEBPACK FOOTER **
 ** ./src/components/profession/profession.js
 **/